import PublicPage from '@/shared/PublicPage/PublicPage';

export default function TermsOfUse() {
  return (
    <PublicPage withFooter>
      <h1>Terms and Conditions of Use</h1>

      <h2>1. Terms</h2>

      <p>
        By accessing this website, you are agreeing to be bound by this
        website's Terms and Conditions of Use, all applicable laws and
        regulations, and agree that you are responsible for compliance with any
        applicable local laws. If you do not agree with any of these terms, you
        are prohibited from using or accessing this site. The materials
        contained in this web site are protected by applicable copyright and
        trade mark law.
      </p>

      <h2>2. Use License</h2>

      <p>
        Unless otherwise stated, Rockalingua owns the intellectual property
        rights in the website and material on the website. Subject to the
        license below, all these intellectual property rights are reserved. You
        may view, and print pages from the website for your own personal or
        professional use subject to the restrictions set out below and elsewhere
        in these terms of use. Worksheets and picture dictionaries may only be
        copy and redistributed within your students.
      </p>

      <p>You may not:</p>

      <ul>
        <li>a) Use the materials for any commercial purpose.</li>

        <li>
          b) Attempt to decompile or reverse engineer any software contained on
          Rockalingua's web site;
        </li>

        <li>
          c) Transfer the materials to another person or "mirror" the materials
          on any other server.
        </li>
      </ul>

      <p>
        This license shall automatically terminate if you violate any of these
        restrictions and may be terminated by Rockalingua at any time.
      </p>

      <h2>3. Disclaimer of Warranties and Limitation of Liability</h2>

      <p>
        ROCKALINGUA WEBSITE INCLUDING THE CONTENT AND ALL INFORMATION,
        MATERIALS, PRODUCTS AND SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE
        TO YOU ARE PROVIDED BY ROCKALINGUA ON AN "AS IS" AND "AS AVAILABLE"
        BASIS, UNLESS OTHERWISE SPECIFIED IN WRITING.
      </p>
      <p>
        ROCKALINGUA MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS
        OR IMPLIED, AS TO THE OPERATION OF THE ROCKALINGUA WEBSITE OR THE
        CONTENT, INFORMATION, MATERIALS, PRODUCTS OR SERVICES INCLUDED ON OR
        OTHERWISE MADE AVAILABLE THROUGH ROCKALINGUA'S WEBSITE, UNLESS OTHERWISE
        SPECIFIED IN WRITING.
      </p>
      <p>
        YOU EXPRESSLY AGREE THAT YOUR USE OF THE ROCKALIMGUA WEBSITE IS AT YOUR
        SOLE RISK.
      </p>
      <p>
        TO THE FULL EXTENT PERMISSIBLE BY APPLICABLE LAW, ROCKALINGUA DISCLAIMS
        ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
        IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
        PURPOSE.
      </p>
      <p>
        ROCKALINGUA DOES NOT WARRANT THAT THE ROCKALINGUA WEBSITE, THE CONTENT,
        INFORMATION, MATERIALS, PRODUCTS OR SERVICES INCLUDED ON OR OTHERWISE
        MADE AVAILABLE THROUGH THE ROCKALINGUA WEBSITE, THEIR SERVER, OR E-MAIL
        SENT FROM ROCKALINGUA ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
      </p>
      <p>
        IN NO EVENT SHALL ROCKALINGUA OR ANY OF ITS AFFILIATES OR CUSTOMERS,
        SUPPLIERS OR THEIR RESPECTIVE MEMBERS, DIRECTORS, EMPLOYEES, PARTNERS OR
        AGENTS BE LIABLE FOR ANY INCIDENTAL, INDIRECT, PUNITIVE, EXEMPLARY, OR
        CONSEQUENTIAL DAMAGES WHATSOEVER (INCLUDING, WITHOUT LIMITATION, DAMAGES
        FOR LOSS OF PROFITS, BUSINESS INTERRUPTION, LOSS OF BUSINESS
        INFORMATION, OR ANY OTHER PECUNIARY LOSS) ARISING FROM THE USE OF THE
        ROCKALINGUA WEBSITE OR FROM THE CONTENT, INFORMATION, MATERIALS,
        PRODUCTS OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE THROUGH THE
        ROCKALINGUA WEBSITE, WHETHER THE DAMAGES ARISE FROM USE OR MISUSE OR
        RELIANCE OR, INABILITY TO USE THE ROCKALINGUA WEBSITE OR ANY OF THE
        CONTENT, INFORMATION, MATERIALS, PRODUCTS OR SERVICES INCLUDED ON OR
        OTHERWISE MADE AVAILABLE THROUGH THE ROCKALINGUA WEBSITE, OR WHETHER
        THEY ARISE FROM THE INTERRUPTION, SUSPENSION, MODIFICATION, ALTERATION,
        OR TERMINATION OF THE ROCKALINGUA WEBSITE OR ANY CONTENT, INFORMATION,
        MATERIALS, PRODUCTS OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE
        THROUGH THE ROCKALINGUA WEBSITE. IN NO EVENT, SHALL ROCKALINGUA'S TOTAL
        MAXIMUM AGGREGATE LIABILITY UNDER THESE TERMS, THE LICENSE PROVIDED
        HEREUNDER, OR THE USE OR EXPLOITATION OF THE ROCKALINGUA WEBSITE IN ANY
        MANNER WHATSOEVER EXCEED THE AMOUNT ACTUALLY PAID, IF ANY, TO
        ROCKALINGUA BY THE INJURED PARTY.
      </p>

      <h2>4. Acceptable use</h2>

      <p>
        You must not use our website in any way that causes, or may cause,
        damage to the website or impairment of the availability or accessibility
        of the website; or in any way which is unlawful, illegal, fraudulent or
        harmful, or in connection with any unlawful, illegal, fraudulent or
        harmful purpose or activity.
      </p>

      <p>
        You must not use our website to copy, store, host, transmit, send, use,
        publish or distribute any material which consists of (or is linked to)
        any spyware, computer virus, Trojan horse, worm, keystroke logger,
        rootkit or other malicious computer software.
      </p>

      <p>
        You must not conduct any systematic or automated data collection
        activities (including, without limitation, scraping, data mining, data
        extraction and data harvesting) on or in relation to our website without
        our express written consent.
      </p>

      <p>
        You must not use our website to transmit or send unsolicited commercial
        communications.
      </p>

      <p>
        You must not use our website for any purposes related to marketing
        without our express written consent.
      </p>

      <h2>5. Restricted access</h2>

      <p>
        Access to certain areas of our website is restricted. We reserve the
        right to restrict access to other areas of our website, or indeed our
        whole website, at our discretion.
      </p>

      <p>
        If [we provide you with / you generate] a user ID and password to enable
        you to access restricted areas of our website or other content or
        services, you must ensure that the password is kept confidential.
      </p>

      <p>
        You must notify us in writing immediately if you become aware of any
        unauthorised use of your account or password.
      </p>

      <p>
        You are responsible for any activity on our website arising out of any
        failure to keep your password confidential and may be held liable for
        any losses arising out of such a failure.
      </p>

      <p>
        You must not use any other person's user ID and password to access our
        website, unless you have that person's express permission to do so.
      </p>

      <p>
        We may disable your user ID and password at any time in our sole
        discretion with or without notice or explanation.
      </p>

      <h2>6. User content</h2>

      <p>
        In these terms of use, "your content" means material (including, without
        limitation, text, images, audio material, video material and
        audio-visual material) that you submit to our website, for whatever
        purpose.
      </p>

      <p>
        You grant to us a worldwide, irrevocable, non-exclusive, royalty-free
        license to use, reproduce, adapt, publish, translate and distribute your
        content in any existing or future media. You also grant to us the right
        to sub-license these rights and the right to bring an action for
        infringement of these rights.
      </p>

      <p>
        You warrant and represent that your content will comply with these terms
        of use.
      </p>

      <p>
        Your content must not be illegal or unlawful, must not infringe any
        third party's legal rights and must not be capable of giving rise to
        legal action whether against you or us or a third party (in each case
        under any applicable law).
      </p>

      <p>
        You must not submit any content to the website that is or has ever been
        the subject of any threatened or actual legal proceedings or other
        similar complaint.
      </p>

      <p>
        We reserve the right to edit or remove any material submitted to our
        website, or stored on our servers, or hosted or published upon our
        website
      </p>

      <h2>7. Indemnity</h2>

      <p>
        You hereby indemnify us and undertake to keep us indemnified against any
        losses, damages, costs, liabilities and expenses (including, without
        limitation, legal expenses and any amounts paid by us to a third party
        in settlement of a claim or dispute on the advice of our legal advisers)
        incurred or suffered by us arising out of any breach by you of any
        provision of these terms of use[, or arising out of any claim that you
        have breached any provision of these terms of use].
      </p>

      <h2>8. Revisions and Errata</h2>

      <p>
        We attempt to provide accurate descriptions of the Content. However, we
        do not warrant that product descriptions or other parts of the Content
        are accurate, complete, reliable, current, or error-free. If Content is
        materially misrepresented, your sole remedy is to cease use of that
        Content and to notify us of the purported error.
      </p>

      <p>Termination</p>

      <p>
        You may stop using the Rockalingua Website and Content at any time and
        at your sole discretion, with no need for justification and with no
        charge, contact Rockalingua and request to delete your account and/or
        disable your subscription. Note that the termination of an account or a
        subscription does not delete the information posted by you and you may
        need to contact Rockalingua directly to request editing, deletion or
        removal of such information.
      </p>

      <p>
        Rockalingua reserves the right to terminate, without prior notice, any
        user account or to suspend any or all of the access to the Content, with
        or without the user's consent, for violating these Terms of Use. If your
        account is terminated, your rights to use the Rockalingua Website and
        the Content will cease immediately. Termination is without prejudice to
        all other remedies available to Rockalingua by law or under these Terms
        of Use.
      </p>

      <p>
        In either of the above two cases, your voluntary termination of
        membership or our cancelation of your membership, Rockalingua will not
        reimburse any portion of fees paid.
      </p>

      <h2>9. Links</h2>

      <p>
        ROCKALINGUA has not reviewed all of the sites linked to its Internet web
        site and is not responsible for the contents of any such linked site.
        The inclusion of any link does not imply endorsement by ROCKALINGUA of
        the site. Use of any such linked web site is at the user's own risk.
      </p>

      <h2>10. Site Terms of Use Modifications</h2>

      <p>
        ROCKALINGUA may revise these terms of use for its web site at any time
        without notice. By using this web site you are agreeing to be bound by
        the then current version of these Terms and Conditions of Use.
      </p>

      <h2>11. Governing Law</h2>

      <p>
        Any claim relating to Rockalingua's web site shall be governed by the
        laws of the State of California without regard to its conflict of law
        provisions.
      </p>
    </PublicPage>
  );
}
